/**
 * 将数组拼接为符串，用symbol链接
 * @description 用于pageview.title
 * @export
 * @param {((string | undefined)[])} arr
 * @param {string} [symbol='-'] 拼接符号
 */
export function concatWithSymbol(arr, symbol = '-') {
    let res = '',
        lastChar = ''
    arr.forEach((t) => {
        if (t != null) {
            lastChar = res.charAt(res.length - 1)
            if (lastChar && lastChar !== symbol) {
                res += symbol + t
            } else {
                res += t
            }
        }
    })
    return res
}
export function concatURI(link, params) {
    if (!params)
        return link;
    const [urlWithoutHash, hash = ''] = link.split('#');
    const [pureUrl, searchParams = ''] = urlWithoutHash.split('?');
    if (!pureUrl)
        return '';
    const qs = new URLSearchParams(searchParams);
    for (const [key, value] of Object.entries(params)) {
        if (value === null || value === void 0) {
            qs.delete(key);
            continue;
        }
        const paramValue = String(value);
        if (!qs.getAll(key).includes(paramValue)) {
            qs.append(key, paramValue);
        }
    }
    const query = [];
    qs.forEach((value, key) => {
        query.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    });
    const result = query.length ? pureUrl + '?' + query.join('&') : pureUrl;
    return hash ? result + '#' + hash : result;
}
